import React from 'react';
import ReportPage from './pages/ReportPage';

function App() {
  return (
    <ReportPage />
  );
}

export default App;